import { render } from "./ConfigPage.vue?vue&type=template&id=a989fdd8&scoped=true"
import script from "./ConfigPage.vue?vue&type=script&lang=js"
export * from "./ConfigPage.vue?vue&type=script&lang=js"

import "./ConfigPage.vue?vue&type=style&index=0&id=a989fdd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a989fdd8"]])

export default __exports__